import { AxiosResponse } from 'axios';
import SecureClient from '../SecureClient';
import { BaseTandemFieldInstanceModel, TandemFieldInstance } from './DTOs';

export default class TandemFieldInstancesClient extends SecureClient {
	public getFieldInstances = (accountId: number): Promise<AxiosResponse<TandemFieldInstance[]>> => {
		return this._api.get<TandemFieldInstance[]>(`TandemAccounts/${accountId}/TandemFieldInstances`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public createFieldInstance = (accountId: number, field: BaseTandemFieldInstanceModel) => {
		return this._api.post<TandemFieldInstance>(`TandemAccounts/${accountId}/TandemFieldInstances`, field, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public updateFieldInstance = (accountId: number, fieldId: number, field: BaseTandemFieldInstanceModel) => {
		return this._api.put<TandemFieldInstance>(`TandemAccounts/${accountId}/TandemFieldInstances/${fieldId}`, field, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public deleteFieldInstance = (accountId: number, fieldId: number): Promise<AxiosResponse> => {
		return this._api.delete(`TandemAccounts/${accountId}/TandemFieldInstances/${fieldId}`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

}